module.exports = __webpack_public_path__ + "static/media/aliyun.df106a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/aliyun.jpg
// module id = 64
// module chunks = 0